// --- Dependencies -------------------------------------------------------------------------------
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// --- Our Modules --------------------------------------------------------------------------------
import Router from "./router";
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <Router />
    </StrictMode>
);

/**
 * Registered only so the browser will offer the home-screen install — the worker intercepts nothing.
 * A failure here costs the install prompt, which is never worth breaking boot over, so it stays quiet.
 */
if ("serviceWorker" in navigator) {
    window.addEventListener("load", async () => {
        try {
            await navigator.serviceWorker.register("/sw.js");
        } catch {
            // Intentionally silent — the dashboard works identically without it.
        }
    });
}
